import axios from 'axios';
import { URL } from './constant/url';

export const getAllArticles = async () => {
    const response = await axios.get(`${URL}/api/getAllArticles`);
    return response;
}

export const postNewSubscriber = async (email, name) => {
    try {
        const SECRET_KEY = "cnWJNkSRbXdnoPHuHQVYMOyGTA3fk34B";

        const timestamp = Math.floor(Date.now() / 1000);

        const secretKeyWithTimestamp = `${SECRET_KEY}$%=&*${timestamp}`;

        const encodedSecretKey = btoa(secretKeyWithTimestamp);
        const headers = {   
            'X-SECRET-KEY': encodedSecretKey,
        };
        
        await axios.post(`${URL}/api/postSubscriber`, {
            email: email,
            name: name
        }, { headers });
        return 200;
    } catch (error) {
        console.error('Error posting subscriber:', error);
        return 400;
    }
}

export const getArticleDetail = async (id) => {
    const response = await axios.get(`${URL}/api/getDetailArticles/${id}`);
    return response;
}